<div class="app-l-page-wrap">
    <div id="courses-listing-page">
        <!-- <page-header
			[headerText]="title"
			[backLink]="backLink"
			[cssClass]="cssModule"
			[backText]="backText"
		></page-header> -->
        <div class="app-l-page__navigation" *ngIf="isLoaded">
            <div class="app-l-page__previous">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                    aria-label="Go to previous page"
                    (click)="goBack()">
                    <svg-icon
                        icon="arrow-left"
                        class="w-100 h-100"
                        alt="go back"></svg-icon>
                </button>
            </div>
            <nav aria-label="Breadcrumb" class="app-l-page__breadcrumbs" *ngIf="showBreadcrumbs">
                <ul>
                    <li class="breadcrumbs-list-item">
                        <a [routerLink]="['/app/series']" translate
                            >series.title</a
                        >
                    </li>
                    <li class="breadcrumbs-list-item" *ngIf="!isOrgContent">
                        <a [routerLink]="['/app/series/video']" translate
                            >series.seriesTypes.video</a
                        >
                    </li>
                    <li
                        class="breadcrumbs-list-item" *ngIf="isOrgContent">
                        <a
                            [routerLink]="['/app/series/org-series-contents']"
                            translate
                            aria-current="false">
                            {{ organizationOwnContentTitle }}
                        </a>
                    </li>
                    <li class="breadcrumbs-list-item"  *ngIf="!isOrgContent">
                        <a [routerLink]="[backLink]">{{
                            courseData[0].courseName
                        }}</a>
                    </li>
                    <li class="breadcrumbs-list-item"  *ngIf="isOrgContent">
                        <a [routerLink]="[backLink]">{{
                            courseData[0].courseName
                        }}</a>
                    </li>
                    <li
                        class="app-l-current-page"
                        aria-current="page"
                        tabindex="0">
                        {{ videoData.label }}
                    </li>
                </ul>
            </nav>
        </div>
        <div class="app-l-cd__base">
            <page-loader *ngIf="!isLoaded"></page-loader>
            <div class="app-l-cd__wrap" *ngIf="isLoaded">
                <div class="app-l-cd__content">
                    <!-- <h3 *ngIf="content.step">{{content.step}}</h3> -->
                    <!-- <div class="page-header-body">
						<p
							aria-live="polite"
							tabindex="0"
							[innerHtml]="chapterDesc"
						></p>
					</div> -->
                    <div class="app-l-cd__block">
                        <course-video-card
                            #videoCard
                            [video]="videoData"
                            [callbackUrl]="callbackUrl"
                            (onVideoCompleted)="videoData.isCompleted = true"
                            (onVideoEnded)="onComplete($event)"
                            (onRate)="onRate(videoData)"
                            [disableControls]="false"
                            (onPause)="pause()"
                            [autoplay]="autoplay"
                            (progressData)="
                                updateCourseVideoList($event)
                            "></course-video-card>
                    </div>

                    <div class="in-app-link-cta" *ngIf="videoData?.inAppLinks?.length">
                        <a *ngFor="let link of videoData.inAppLinks"
                            class="app-c-btn app-c-btn--primary app-c-btn--curve"
                            [routerLink]="inAppLinkRoute(link)">
                            {{ link.label | translate }}
                        </a>
                    </div>
                </div>
                <div class="app-l-cd__sidebar">
                    <div class="app-l-cd__progress">
                        <h3>
                            {{
                                'theory.courseVideosCompleted'
                                    | translate
                                        : {
                                              completed: getCompleted(),
                                              total: courseVideos.length
                                          }
                            }}
                        </h3>
                        <div class="app-l-cd__progress-bar">
                            <div
                                class="app-l-cd__progress-fill"
                                [style.width]="progress + '%'"></div>
                        </div>
                    </div>

                    <!-- <div class="about-course col-lg-12">
							<h2>About the course</h2>
							<span>{{ courseData.description }}</span>
						</div> -->

                    <div
                        class="app-l-cd__other-course"
                        *ngIf="courseVideos.length">
                        <!-- <h2 translate>theory.otherCourseVideos</h2> -->
                        <ng-container
                            *ngFor="let video of courseVideos; let i = index">
                            <div
                                tabindex="0"
                                [attr.aria-label]="
                                    video.id === videoData.id
                                        ? 'Currently Playing ' +
                                          video.label +
                                          ' video'
                                        : 'Play ' + video.label + ' video'
                                "
                                class="app-l-other-course__block"
                                [ngClass]="{
                                    watching: video.id === selectedVideo.id
                                }"
                                (click)="changeCourseVideo(video)"
                                (keypress)="changeCourseVideo(video)">
                                <!-- add class "completed for completed video items and add class "watching" for watching items"-->
                                <div class="app-l-other-course__image">
                                    <img
                                        [defaultImage]="
                                            'https://ionicframework.com/docs/img/demos/card-media.png'
                                        "
                                        [lazyLoad]="video.image" />
                                </div>
                                <div class="app-l-other-course__content">
                                    <h3
                                        class="app-l-other-course__name"
                                        translate>
                                        theory.courseVideos
                                    </h3>
                                    <h4 class="app-l-other-course__title">
                                        {{ video.label }}
                                    </h4>
                                    <!-- <p class="video-card-count">10,456 learners</p> -->
                                </div>
                                <div
                                    class="app-l-other-course__status status-completed"
                                    *ngIf="
                                        video.courseProgress.Status ===
                                        'completed'
                                    ">
                                    <svg-icon
                                        icon="tick-circle-outline"
                                        class="w-100 h-100"
                                        alt="completed"></svg-icon>
                                </div>
                                <div
                                    class="app-l-other-course__status status-watching"
                                    *ngIf="
                                        video.courseProgress.Status ===
                                            'inprogress' &&
                                        video.courseProgress.TimeCompleted !== 0
                                    ">
                                    <svg-icon
                                        icon="timer"
                                        class="w-100 h-100"
                                        alt="inprogress"></svg-icon>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
